import React, { useEffect, useMemo, useState } from "react";
import { Form, Offcanvas, Table } from "react-bootstrap";
import { MdRestore } from "react-icons/md";
import { NoDataFoundTable } from "../../../Components/NoDataFoundTable/NoDataFoundTable";

const DeletedLupDataset = ({
  tableRef,
  onMouseDown,
  LUPReportDeletedDataset,
  softDeleteRestoreEDCLupData,
  Show,
  Hide,
  Title,
}) => {
  return (
    <Offcanvas
      show={Show}
      onHide={Hide}
      style={{ width: 600 }}
      placement="end"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0">
        {LUPReportDeletedDataset?.length === 0 ? (
          <div
            className="hstack justify-content-center"
            style={{ height: "calc(100vh - 44px)" }}
          >
            <NoDataFoundTable MSG={"No Deleted File."} />
          </div>
        ) : (
          <Table ref={tableRef} className="m-0 custom-table" hover striped>
            <thead className="position-sticky top-0">
              <tr>
                <th
                  onMouseDown={(e) => onMouseDown(e, 0)}
                  style={{ width: 45 }}
                  className="text-center"
                >
                  Sr.
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 1)}>Name</th>
                <th onMouseDown={(e) => onMouseDown(e, 2)}>Category</th>
                <th
                  onMouseDown={(e) => onMouseDown(e, 3)}
                  style={{ width: 55 }}
                  className="text-center"
                >
                  Restore
                </th>
              </tr>
            </thead>
            <tbody>
              {LUPReportDeletedDataset?.map((file, index) => {
                return (
                  <tr key={index} title="View Details">
                    <td className="text-center">{index + 1}.</td>
                    <td>{file?.name}.glxdat</td>
                    <td>{file?.type}</td>
                    <td className="text-center" title="Restore">
                      <MdRestore
                        style={{ fontSize: 16 }}
                        className="text-success CP"
                        onClick={() => softDeleteRestoreEDCLupData(
                          file?._id,
                          "restore",
                        )}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};
export default DeletedLupDataset;